import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTriangleExclamation } from '@fortawesome/free-solid-svg-icons';
import { WorkflowLock } from '../../services/workflowClient';

const WorkflowLockBanner: React.FC<{ lock?: WorkflowLock | null }> = ({
	lock,
}) => {
	if (!lock?.locked) {
		return null;
	}

	return (
		<div className="flex items-center gap-4 rounded-md border border-amber-300 bg-amber-50 p-4 text-sm text-amber-950">
			<span className="shrink-0 text-5xl leading-none text-amber-500">
				<FontAwesomeIcon icon={faTriangleExclamation} />
			</span>
			<div>
				<p className="font-medium">{lock.message}</p>
				{lock.remedy && <p className="mt-1">{lock.remedy}</p>}
			</div>
		</div>
	);
};

export default WorkflowLockBanner;
